import AboutUsItem from "../components/AboutUsItem";
import "./AboutUs.css";
import Footer from "../components/Footer";
import { Offcanvas } from "react-bootstrap";
import { useEffect, useState } from "react";
import { hideNavAction } from "../store/actions/showNavAction";
import { useDispatch } from "react-redux";
import lolo from "./images/lolo.png";
import justina from "./images/justina.jpg";
import maday from "./images/maday.png";
import pierre from "./images/pierre.jpg";
import credentials from "./images/credentials.png";

function AboutUs() {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [git, setGit] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [bio, setBio] = useState("");
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handleShow = (selectedProfile) => {
    const profiles = {
      1: {
        name: "Lorenzo Grignola",
        picture: lolo,
        git: "https://github.com/lologrignola",
        linkedin: "https://www.linkedin.com/in/lorenzo-grignola-a34028216/",
        bio: "Viví en España toda mi infancia y parte de mi adolescencia, llegué a Uruguay hace 6 años y me enamoré del país. Siempre supe que mi futuro era con las computadoras, por ello fui a Bachillerato Informático. Después hice un año de FING (Ing. en Computación) y decidí pausarla momentáneamente para poder insertarme en el campo laboral de lo que verdaderamente me apasiona. Es por eso que este año hice un Bootcamp en Hack Academy. Ahora me encuentro en la busqueda de mi primera experiencia laboral como programador",
      },

      2: {
        name: "Justina Boxer",
        picture: justina,
        git: "https://github.com/justinaboxer",
        linkedin: "https://www.linkedin.com/in/justina-boxer",
        bio: "Luego de 10 años de trabajo en el área comercial de la industria financiera, principalmente con clientes y relaciones internacionales,  me desafié a apostar por mi pasión por el diseño y creatividad, buscando fusionar mi experiencia en el sector financiero con el desarrollo web.",
      },
      3: {
        name: "Pierre Poumayrac",
        picture: pierre,
        git: "https://github.com/vitricida",
        linkedin: "https://www.linkedin.com/in/pierre-poumayrac/",
        bio: "Soy Licenciado en Imagenología convertido en Desarrollador web. Todas mis experiencias laborales han sido vinculadas al trato con la gente, me apasiona resolver problemas complejos y temas vinculados a TI en el rubro de salud. Esto último fue lo que me llevó a incursionar en el mundo de la programación.",
      },
      4: {
        name: "Maday Concepción",
        picture: maday,
        git: "https://github.com/madaycg",
        linkedin: "https://www.linkedin.com/in/madaycg/",
        bio: "Después de haber estudiado odontología y ejercido durante dos años en mi país de origen Cuba, en el 2020 llegué a Uruguay  en busca de mejores oportunidades, donde decidí realizar un cambio profesional.  La tecnología siempre fue de mi interés como medio para solucionar problemas, por lo que comencé a formarme como desarrolladora web.",
      },
    };
    setName(profiles[selectedProfile].name);
    setProfilePic(profiles[selectedProfile].picture);
    setGit(profiles[selectedProfile].git);
    setLinkedin(profiles[selectedProfile].linkedin);
    setBio(profiles[selectedProfile].bio);
    setShow(true);
  };

  useEffect(() => {
    dispatch(hideNavAction());
    window.scrollTo(0, 0);
  }, []);

  const backConfig = {
    background: `linear-gradient(0deg,rgb(78, 78, 78) 0%,rgba(97, 70, 71, 0.711) 82%,rgb(236, 219, 195) 100%), url(${process.env.PUBLIC_URL}img/vid.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div className="">
      <div id="header-sobre-nosotros" className="mt-5 pt-5 img-fluid" style={backConfig}>
        <div className="container"></div>
        <div className="container">
          <div className="col-md-6">
            <h1>Sobre este proyecto</h1>
            <p className="pt-2">
              Este proyecto surge como trabajo final del curso intensivo (coding Bootcamp) realizado
              de la mano de Hack Academy.{" "}
            </p>

            <p className="pt-2">
              La metodología Bootcamp entrena y prepara a las personas a través de un método de
              aprendizaje intensivo donde el foco principal es desarrollar las habilidades
              necesarias para el desempeño exitoso en el mercado laboral.
            </p>

            <p className="pt-2">
              Empleando más de <strong>600 horas</strong> de trabajo en ejercicios prácticos y
              compartiendo varias instancias de trabajo en equipo, nos preparamos de acuerdo a las
              necesidades del mercado para poder insertarnos y formar parte de la industria.
            </p>
          </div>
          ;
        </div>
        <div className="container">
          <div id="tecnologias">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="react"
                className="svg-inline--fa fa-react fa-w-16"
                role="img"
                viewBox="0 0 512 512"
                width="2rem"
                height="2rem"
                color="white"
              >
                <path
                  fill="currentColor"
                  d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                />
              </svg>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 282.72 64"
                width="4rem"
                height="4rem"
                color="white"
              >
                <path
                  d="M141.04 16c-11.04 0-19 7.2-19 18s8.96 18 20 18c6.67 0 12.55-2.64 16.19-7.09l-7.65-4.42c-2.02 2.21-5.09 3.5-8.54 3.5-4.79 0-8.86-2.5-10.37-6.5h28.02c.22-1.12.35-2.28.35-3.5 0-10.79-7.96-17.99-19-17.99zm-9.46 14.5c1.25-3.99 4.67-6.5 9.45-6.5 4.79 0 8.21 2.51 9.45 6.5zM248.72 16c-11.04 0-19 7.2-19 18s8.96 18 20 18c6.67 0 12.55-2.64 16.19-7.09l-7.65-4.42c-2.02 2.21-5.09 3.5-8.54 3.5-4.79 0-8.86-2.5-10.37-6.5h28.02c.22-1.12.35-2.28.35-3.5 0-10.79-7.96-17.99-19-17.99zm-9.45 14.5c1.25-3.99 4.67-6.5 9.45-6.5 4.79 0 8.21 2.51 9.45 6.5zM200.24 34c0 6 3.92 10 10 10 4.12 0 7.21-1.87 8.8-4.92l7.68 4.43c-3.18 5.3-9.14 8.49-16.48 8.49-11.05 0-19-7.2-19-18s7.96-18 19-18c7.34 0 13.29 3.19 16.48 8.49l-7.68 4.43c-1.59-3.05-4.68-4.92-8.8-4.92-6.07 0-10 4-10 10zm82.48-29v46h-9V5zM36.95 0L73.9 64H0zm92.38 5l-27.71 48L73.91 5H84.3l17.32 30 17.32-30zm58.91 12v9.69c-1-.29-2.06-.49-3.2-.49-5.81 0-10 4-10 10V51h-9V17h9v9.2c0-5.08 5.91-9.2 13.2-9.2z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="3rem"
                height="3rem"
                color="white"
                viewBox="0 0 32 32"
              >
                <g transform="matrix(.249635 0 0 .249239 -63.665715 -106.04659)">
                  <path
                    d="M320.213 480.665c3.27 0 5.748-.7 7.437-2.133s2.533-3.52 2.533-6.293c0-2.738-.844-4.818-2.533-6.24-1.7-1.458-4.168-2.187-7.437-2.187h-11.48v16.854h11.48m.7 34.827c4.167 0 7.293-.87 9.377-2.613 2.12-1.742 3.18-4.373 3.18-7.893 0-3.45-1.042-6.027-3.126-7.733-2.084-1.742-5.227-2.613-9.43-2.613h-12.18v20.854h12.18m19.293-28.64c4.455 1.28 7.904 3.645 10.347 7.093s3.664 7.68 3.665 12.694c0 7.68-2.623 13.405-7.868 17.174s-13.22 5.653-23.927 5.653h-34.436V449.84h31.15c11.173 0 19.257 1.67 24.25 5.013 5.03 3.342 7.545 8.694 7.545 16.054 0 3.876-.916 7.182-2.748 9.92-1.832 2.702-4.5 4.7-7.976 6.027"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="8rem" height="4rem" color="white">
                <path
                  d="M16.147 5.154l1.09 2.05a6.15 6.15 0 0 0 .824 1.024c.913.913 1.782 1.87 2.56 2.895 1.848 2.427 3.095 5.122 3.986 8.04.534 1.782.824 3.608.846 5.456.09 5.523-1.804 10.266-5.634 14.208a16.3 16.3 0 0 1-2.004 1.715c-.38 0-.557-.3-.713-.557-.3-.5-.468-1.047-.557-1.603-.134-.668-.223-1.336-.178-2.027v-.312c-.022-.067-.356-30.732-.223-30.888z"
                  fill="#fff"
                />
                <path
                  d="M16.147 5.088c-.045-.09-.09-.022-.134.022.022.445-.134.846-.38 1.225-.267.38-.624.668-.98.98-1.982 1.715-3.54 3.786-4.788 6.102-1.648 3.118-2.516 6.458-2.76 9.977-.11 1.27.4 5.746.802 7.037 1.09 3.43 3.05 6.302 5.6 8.796.624.6 1.292 1.158 1.982 1.692.2 0 .223-.178.267-.312a6.11 6.11 0 0 0 .2-.869c.2-1.113.312-2.227.445-3.34l-.245-31.31z"
                  fill="#fff"
                />
                <path
                  d="M17.24 41.9c.045-.512.3-.935.557-1.358-.267-.11-.468-.334-.624-.58-.134-.223-.245-.5-.334-.735-.312-.935-.38-1.915-.468-2.873v-.58c-.11.09-.134.846-.134.958-.067 1.024-.2 2.027-.4 3.006-.067.4-.11.802-.356 1.158 0 .045 0 .09.022.156.4 1.18.512 2.383.58 3.608v.445c0 .534-.022.423.423.6.178.067.38.09.557.223.134 0 .156-.11.156-.2l-.067-.735v-2.05c-.022-.356.045-.713.09-1.047z"
                  fill="#fff"
                />
                <g transform="matrix(1.021124 0 0 1.021124 -4.376266 -1.845946)">
                  <path
                    d="M37.73 33.72v2.077a1.45 1.45 0 0 0 .014.246c.027.246.178.396.4.465a4.97 4.97 0 0 0 .63.123c.123.014.164.068.178.2.014.465-.027.52-.478.492-1.052-.055-2.105-.068-3.157 0h-.1c-.328.014-.355-.014-.355-.342 0-.055.014-.123.014-.178 0-.1.068-.15.164-.15.22-.027.424-.082.63-.123.287-.068.45-.246.478-.533.04-.314.04-.642.04-.957l.014-3.662a.56.56 0 0 0-.3-.52 3.89 3.89 0 0 0-.78-.328c-.082-.027-.164-.04-.232-.082-.2-.096-.205-.273-.014-.383.068-.04.15-.068.232-.082a12.42 12.42 0 0 0 2.432-.615c.164-.055.205-.04.22.123.014.1 0 .22-.014.314-.027.178-.027.355-.027.52 0 .068.014.137.082.178s.137 0 .2-.04c.287-.22.574-.424.888-.6.45-.246.93-.465 1.45-.533.63-.082 1.175.082 1.654.492a3.1 3.1 0 0 1 .519.601c.137.2.15.205.328.068.52-.383 1.066-.724 1.654-.97.615-.26 1.244-.3 1.872-.082.642.232 1.08.683 1.34 1.298.22.492.314 1 .314 1.53v3.662c0 .246.1.4.342.52.26.1.547.15.82.205.178.04.178.04.178.22-.027.45-.068.478-.506.45a29.42 29.42 0 0 0-3.293 0c-.22.014-.22.014-.232-.205v-.068c-.014-.37-.014-.37.342-.45l.355-.096a.55.55 0 0 0 .424-.533l.04-1.025-.027-2.678a2.13 2.13 0 0 0-.15-.697c-.342-.834-1.093-1.134-1.818-1.052-.547.055-1.025.273-1.476.588-.096.068-.164.15-.15.287.123.875.04 1.75.055 2.624v1.9c0 .342.137.506.465.588l.63.137c.096.014.15.055.15.164v.1c-.014.383-.04.4-.424.396-1.093-.055-2.187-.04-3.266 0-.37.014-.4-.027-.383-.4.014-.22.04-.232.246-.273l.45-.082c.4-.082.547-.232.574-.656l.04-.916-.027-2.747c-.027-.342-.1-.67-.287-.984-.273-.506-.7-.765-1.285-.793-.588-.04-1.107.178-1.6.45-.342.2-.492.437-.465.834v1.995zm25.747.083v1.927a4.13 4.13 0 0 0 .027.41.42.42 0 0 0 .328.383 3.19 3.19 0 0 0 .724.123c.137.014.164.068.178.178v.096c-.014.478-.068.533-.533.506-1.04-.068-2.077-.055-3.116 0l-.4.014c-.082 0-.1-.04-.123-.096a1.39 1.39 0 0 1 0-.574c.014-.082.068-.1.15-.123.2-.027.37-.068.56-.1.342-.082.465-.22.478-.574l.04-1.148v-3.362c0-.246-.096-.396-.314-.506-.246-.137-.506-.232-.78-.328-.082-.027-.164-.055-.232-.096-.178-.123-.2-.3-.027-.437a.49.49 0 0 1 .273-.11c.875-.137 1.722-.328 2.542-.656.096-.04.137-.014.178.068s.055.178.04.273l-.04.642c0 .082-.04.2.027.232.082.055.137-.068.205-.1a6.09 6.09 0 0 1 1.326-.847c.424-.2.86-.328 1.353-.3.916.055 1.572.52 1.995 1.326.22.424.314.888.355 1.367l.04 1 .014 3.02c.014.232.096.383.328.465a4.47 4.47 0 0 0 .738.178c.22.027.232.068.246.273v.068c-.027.465-.055.478-.52.45a28.59 28.59 0 0 0-3.061 0c-.137.014-.273 0-.4.014-.082 0-.137-.014-.15-.096-.027-.178-.055-.355-.014-.547.014-.082.055-.123.15-.137l.63-.1c.22-.055.342-.2.37-.4l.027-.383-.014-2.856c0-.328-.014-.656-.082-.984-.164-.7-.697-1.2-1.42-1.27-.63-.068-1.2.096-1.722.437-.26.164-.37.396-.37.683v2.064c0-.04 0-.04.014-.04z"
                    fill="#fff"
                  />
                  <path
                    d="M103.503 29.935c-.15-.998-.52-1.886-1.162-2.665a5.27 5.27 0 0 0-2.105-1.558c-.86-.355-1.777-.465-2.706-.492-.383-.014-5.603.068-5.986 0-.096-.014-.164.014-.22.096-.068.1-.137.205-.178.314-.164.37-.164.342.232.396.328.055.642.082.957.178.287.096.492.26.56.574.027.15.055 4.96.055 7.202l-.055 1.6c-.014.123-.027.246-.068.355-.055.164-.15.3-.314.37a1.62 1.62 0 0 1-.574.15c-.37.04-.424.055-.547.465l-.04.15c-.027.178-.014.205.164.205l4.086.04 1.6-.027 1.107-.137c1.257-.232 2.378-.752 3.334-1.585a5.55 5.55 0 0 0 1.312-1.722c.383-.765.547-1.6.588-2.446.068-.478.04-.97-.04-1.462zm-1.982 1.94c-.055.875-.232 1.722-.683 2.487-.574.998-1.394 1.695-2.528 1.94-.492.1-.984.15-1.5.082-.37-.04-.724-.082-1.066-.205-.615-.22-.834-.6-.847-1.2l-.014-8.24c0-.492.22-.6.574-.615.533-.04 1.08-.027 1.613.027a6.06 6.06 0 0 1 1.654.4 3.98 3.98 0 0 1 1.08.67c.738.63 1.23 1.42 1.5 2.35.22.752.26 1.517.22 2.282zm13.34 1.34c0-.082 0-.15-.014-.232-.123-.752-.52-1.326-1.134-1.763-.396-.287-.847-.478-1.312-.615-.082-.027-.15-.055-.232-.068.014-.068.055-.082.096-.096.273-.137.533-.287.765-.492.424-.355.7-.793.847-1.326.082-.287.082-.574.055-.875a2.35 2.35 0 0 0-.998-1.777c-.63-.465-1.367-.656-2.132-.67-1.476-.027-2.965 0-4.44 0-.424 0-.847.027-1.285-.04-.082-.014-.2-.04-.26.055-.1.178-.22.355-.26.56-.014.096.014.15.123.164l.943.137c.37.055.63.26.656.588a5.78 5.78 0 0 1 .04.683l-.027 2.555-.014 5.056c0 .3-.04.588-.096.888a.5.5 0 0 1-.355.41c-.273.082-.533.164-.82.164a.34.34 0 0 0-.355.232c-.055.123-.1.26-.123.383-.027.164.014.22.178.2.123-.014 4.633.096 5.48.014.506-.055 1-.123 1.503-.273.86-.273 1.654-.67 2.282-1.34.52-.547.82-1.203.847-1.968.04-.178.04-.355.04-.547zm-6.628-5.6l.04-1.093c0-.205.082-.3.287-.342.328-.068.656-.04.984-.027.328.027.642.068.97.164.6.178 1.066.52 1.34 1.093a1.96 1.96 0 0 1 .191.834c.014.383-.014.752-.164 1.12-.232.506-.6.834-1.134.93s-2.05.055-2.282.055c-.205 0-.22-.027-.22-.232V28.83a8.79 8.79 0 0 1-.014-1.203zm4.44 7.352c-.232.615-.656 1.04-1.257 1.27-.328.123-.656.2-1 .178-.424-.014-.847 0-1.27-.082-.574-.123-.834-.67-.875-1.066-.068-.697-.027-1.408-.04-1.927v-1.804c0-.22.027-.287.26-.287l1.285.014.875.1c.615.137 1.175.37 1.613.847.355.383.547.847.588 1.353.04.478.014.943-.164 1.394z"
                    fill="#fff"
                  />
                  <path d="M77.95 30.85l.355.055c.383.014.834-.123.97-.656a1.38 1.38 0 0 0 0-.78c-.082 0-.123.068-.164.096-.205.164-.437.26-.683.287-.492.055-.984.027-1.462-.15l-.67-.232a3.95 3.95 0 0 0-1.45-.19c-.697.055-1.353.287-1.968.615-.656.355-1.12.888-1.34 1.613-.123.424-.137.86-.082 1.298.137.998.656 1.695 1.585 2.064.055.014.096.04.15.055.123.068.137.137.027.232l-.342.232-.82.506c-.205.123-.232.22-.164.437a1.43 1.43 0 0 0 .437.656 2.28 2.28 0 0 0 .629.383c.15.068.15.1.014.22l-.78.56c-.26.2-.52.4-.738.656a1.35 1.35 0 0 0-.328 1.23 2.31 2.31 0 0 0 .71 1.23 2.9 2.9 0 0 0 1.257.683c.765.22 1.558.232 2.337.082 1.12-.205 2.1-.7 2.87-1.544.533-.56.847-1.216.875-2a1.92 1.92 0 0 0-1.476-1.995l-.738-.137-2.255-.2c-.246-.014-.492-.055-.697-.178-.26-.164-.328-.478-.164-.683.123-.15.273-.246.465-.26l.437-.04a3.96 3.96 0 0 0 2.309-1.052 2.42 2.42 0 0 0 .697-1.162c.164-.588.164-1.2.027-1.8-.04-.15-.027-.164.164-.137zm-3.35 6.807c.082.014.164 0 .246 0 .574.027 1.162.068 1.722.22a3.58 3.58 0 0 1 .533.205c.547.3.752.82.683 1.38-.082.615-.424 1.052-.957 1.34-.355.2-.752.287-1.162.328-.15.014-.287 0-.437 0-.478.014-.943-.04-1.394-.232-.314-.123-.574-.3-.806-.547-.478-.478-.7-1.353.014-2.064.437-.4.93-.683 1.558-.63zm1.558-4.264c-.287.724-.916.943-1.544.847-.574-.082-.998-.396-1.27-.916-.355-.697-.45-1.42-.246-2.173.15-.56.492-.984 1.093-1.08.765-.137 1.5.137 1.886.902.2.37.287.82.287 1.462-.014.26-.068.615-.205.957zm-17.218-.93c-.123-.738-.396-1.408-.902-1.968-.752-.834-1.708-1.2-2.788-1.203-.943-.014-1.83.26-2.624.752a3.56 3.56 0 0 0-1.599 2.091c-.232.793-.22 1.6-.04 2.405.478 2.16 2.146 3.088 4.14 2.952.588-.04 1.148-.232 1.68-.492.793-.37 1.367-.957 1.763-1.736.314-.642.45-1.326.437-2.105l-.068-.697zM57 35.497a1.66 1.66 0 0 1-1.408 1.148c-.6.082-1.162-.068-1.667-.424a2.84 2.84 0 0 1-.861-1.025c-.56-1.148-.656-2.35-.37-3.58a2.05 2.05 0 0 1 .574-.998c.506-.465 1.093-.574 1.75-.437.63.137 1.107.478 1.5.998s.574 1.12.683 1.75c.055.314.055.642.068.847 0 .656-.055 1.2-.26 1.722zm31.8-2.924c-.1-.793-.396-1.517-.957-2.118-.738-.806-1.695-1.148-2.76-1.162-.916-.014-1.763.246-2.542.697-.875.52-1.476 1.257-1.708 2.255a4.77 4.77 0 0 0 .328 3.252c.45.957 1.216 1.572 2.228 1.845 1.12.3 2.187.164 3.225-.342.902-.437 1.544-1.12 1.913-2.05.22-.547.3-1.134.314-1.818.014-.123-.014-.342-.04-.56zm-1.886 2.747c-.22.738-.683 1.216-1.462 1.326-.574.082-1.12-.055-1.613-.383-.424-.287-.724-.67-.943-1.12-.246-.478-.383-.984-.437-1.503-.082-.642-.082-1.27.068-1.913a1.95 1.95 0 0 1 .123-.369c.383-.957 1.23-1.394 2.228-1.175.67.15 1.175.52 1.558 1.08.37.547.547 1.148.63 1.8.04.26.055.533.04.765 0 .533-.04 1.025-.2 1.503z" />
                </g>
              </svg>
            </div>
          </div>
        </div>
        <>
          <button className="float" id="menu-share">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="users"
              className="svg-inline--fa fa-users fa-w-20"
              role="img"
              viewBox="0 0 640 512"
              width="2.5rem"
              height="2.5rem"
            >
              <path
                fill="currentColor"
                d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
              />
            </svg>
          </button>
          <ul id="sobre-nosotros">
            <li>
              <button onClick={() => handleShow(1)}>Lorenzo Gringola</button>
            </li>
            <li>
              <button onClick={() => handleShow(2)}>Justina Boxer</button>
            </li>
            <li>
              <button onClick={() => handleShow(3)}>Pierre Poumayrac</button>
            </li>
            <li>
              <button onClick={() => handleShow(4)}>Maday Concepción</button>
            </li>
          </ul>
          <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton> </Offcanvas.Header>
            <Offcanvas.Body className="d-flex justify-content-center">
              <AboutUsItem
                name={name}
                profilePic={profilePic}
                git={git}
                linkedin={linkedin}
                bio={bio}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </>
      </div>
      <section id="tech-usada">
        <div className="container">
          <div className="row pt-4">
            <div className="col-md-6">
              <div className="p-5">
                <h5 className="text-center">Tecnologías usadas</h5>
                <div className="d-flex justify-content-between">
                  <div className="me-5">
                    <h6>Front-end React</h6>
                    <ul>
                      <li>Redux</li>
                      <li>React-router-dom</li>
                      <li>Bootstrap</li>
                      <li>Github</li>
                      <li>Font Awesome</li>
                    </ul>
                  </div>
                  <div>
                    <h6>Back-end</h6>
                    <ul>
                      <li>MongoDB</li>
                      <li>Express</li>
                      <li>JWT</li>
                      <li>Formidable</li>
                      <li>Bcryptjs</li>
                      <li>Vercel</li>
                      <li>MongoDB Atlas</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 text-center">
              <div className="pt-5">
                <h5>Video demo</h5>
                <video className="video_mini rounded img-fluid" autoPlay loop muted playsInline>
                  <source src={`/video/The_Wine_Cabinet.mp4`} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="credentials" className="pt-4 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-4">
              <h5>¿Cómo utilizar esta web?</h5>
              <h6>Consumidores</h6>
              <p>
                La web se encuentra disponible para navegar y preparar la compra de forma pública.
                Es indispensable generar un registro y estar logueado a la hora de querer finalizar
                la misma
              </p>
              <h6>Administrador</h6>
              <p>
                Para poder realizar funcionalidades del CRUD tanto para productos, categorías y
                usuarios, es necesario realizar el login correspondiente utilizando el usuario
                precreado ADMIN. Una vez logueado dirigirse a la sección del perfil de usuario
                haciendo click en el icono{" "}
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="green"
                  className="me-2"
                >
                  <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
                </svg>
                del Navbar.
              </p>
              <p className="d-flex align-items-baseline">
                {" "}
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="me-2"
                >
                  <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
                </svg>
                <span>
                  <strong> usuario: </strong>admin
                </span>
              </p>
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="lock"
                  className="svg-inline--fa fa-lock fa-w-14 me-2"
                  role="img"
                  viewBox="0 0 448 512"
                  width="1em"
                  height="1em"
                >
                  <path
                    fill="currentColor"
                    d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                  />
                </svg>
                <span>
                  <strong>contraseña:</strong> admin
                </span>
              </p>
            </div>
            <div className="col-md-6 mb-4">
              <div className="d-flex justify-content-center mt-5 mx-3">
                <img
                  id="indications"
                  className="rounded img-fluid"
                  src={`${credentials}`}
                  alt="placeholder"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="about-us">
        <div className="container">
          <h5 className="mb-3 px-3 text-center" style={{ fontSize: "2rem", color: "212529" }}>
            Equipo
          </h5>
          <div style={{ borderBottom: "solid 0.5px #bdb9b9" }}>
            <AboutUsItem
              name={"Lorenzo Grignola"}
              profilePic={lolo}
              git="https://github.com/lologrignola"
              linkedin="https://www.linkedin.com/in/lorenzo-grignola-a34028216/"
              bio="Viví en España toda mi infancia y parte de mi adolescencia, llegué a Uruguay hace 6 años y me enamoré del país. Siempre supe que mi futuro era con las computadoras, por ello fui a Bachillerato Informático. Después hice un año de FING (Ing. en Computación) y decidí pausarla momentáneamente para poder insertarme en el campo laboral de lo que verdaderamente me apasiona. Es por eso que este año hice un Bootcamp en Hack Academy. Ahora me encuentro en la busqueda de mi primera experiencia laboral como programador."
            />
          </div>
          <div style={{ borderBottom: "solid 0.5px #bdb9b9" }}>
            <AboutUsItem
              name={"Justina Boxer"}
              profilePic={justina}
              git="https://github.com/justinaboxer"
              linkedin="https://www.linkedin.com/in/justina-boxer/"
              bio="Luego de 10 años de trabajo en el área comercial de la industria financiera, principalmente con clientes y relaciones internacionales,  me desafié a apostar por mi pasión por el diseño y creatividad, buscando fusionar mi experiencia en el sector financiero con el desarrollo web."
            />
          </div>
          <div style={{ borderBottom: "solid 0.5px #bdb9b9" }}>
            <AboutUsItem
              name={"Pierre Poumayrac"}
              profilePic={pierre}
              git="https://github.com/vitricida"
              linkedin="https://www.linkedin.com/in/pierre-poumayrac/"
              bio="Soy Licenciado en Imagenología convertido en Desarrollador web. Todas mis experiencias laborales han sido vinculadas al trato con la gente, me apasiona resolver problemas complejos y temas vinculados a TI en el rubro de salud. Esto último fue lo que me llevó a incursionar en el mundo de la programación."
            />
          </div>
          <div style={{ borderBottom: "solid 0.5px #bdb9b9" }}>
            <AboutUsItem
              name={"Maday Concepción"}
              profilePic={maday}
              git="https://github.com/madaycg"
              linkedin="https://www.linkedin.com/in/madaycg/"
              bio="Después de haber estudiado odontología y ejercido durante dos años en mi país de origen Cuba, en el 2020 llegué a Uruguay  en busca de mejores oportunidades, donde decidí realizar un cambio profesional.  La tecnología siempre fue de mi interés como medio para solucionar problemas, por lo que comencé a formarme como desarrolladora web."
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
